import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import withStyles from '@material-ui/core/styles/withStyles'
import { SearchIcon } from '../../../../uiKit/icons/Icons'
import Heading from '../../../../uiKit/texts/Heading'
import { RulesList } from './components/RulesList'

const styles = theme => ({
  inputHolder: {
    border: '1px solid var(--color-ghost-grey)',
    width: 'max-content',
    borderRadius: '10px',
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: 'var(--color-white)',
    marginRight: 10,
    padding: 10,
    maxHeight: 45,
    minWidth: 340,
  },
  paragraph: {
    fontFamily: 'Lato',
    fontSize: 15,
    fontWeight: 500,
    color: 'var(--color-text-secondary)',
  },
  input: {
    width: '100%',
    padding: '10px',
    border: 'none',
    outline: 'none',
    borderRadius: '5px',
    fontSize: '14px',
    lineHeight: '19px',
    backgroundColor: 'var(--color-white)',
  },
  submitButton: {
    backgroundColor: 'var(--color-button-primary)',
    boxShadow: '0px 3px 9px rgba(19, 69, 186, 0.206267)',
    borderRadius: 10,
    height: 45,
    outline: 'none',
    '&:hover': {
      backgroundColor: 'var(--color-button-primary)',
    },
  },
  submitButtonText: {
    color: 'var(--color-text-on-primary)',
    margin: 0,
    fontWeight: 500,
    fontSize: 16,
    textTransform: 'none',
    fontFamily: 'Lato, sans-serif',
  },
  paper: {
    padding: '30px 50px 24px',
  },
  tableCellData: {
    margin: 'auto 0',
  },
  userImageContainer: {
    height: 40,
    flex: '0 0 40px',
    position: 'relative',
    marginRight: 8,
  },
  userImage: {
    display: 'block',
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    objectPosition: 'top',
    borderRadius: '50%',
    overflow: 'hidden',
  },
  userStatus: {
    position: 'absolute',
    boxSizing: 'border-box',
    width: 10,
    height: 10,
    border: '2px solid var(--color-white)',
    borderRadius: '50%',
    bottom: 0,
    right: 0,
  },
})

const Rules = ({ classes }) => {
  const [searchRule, setSearchRule] = useState('')

  const handleSearchRule = (value: string): void => {
    setSearchRule(value)
  }

  return (
    <div style={{ paddingBottom: '36px' }}>
      <Heading>Dataset Rules</Heading>

      <p className={classes.paragraph} style={{ marginBottom: 26 }}>
        The tab helps to enable custom rules for the particular dataset.
      </p>

      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 20,
        }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div className={classes.inputHolder}>
            <input
              className={classes.input}
              placeholder="Search rules"
              onChange={event => handleSearchRule(event.target.value)}
            />
            <SearchIcon width="20" height="20" color="var(--color-mischka-grey)" />
          </div>
        </div>
        {/*<Button className={classes.submitButton} onClick={() => alert('Development in progress')}>*/}
        {/*  <p className={classes.submitButtonText}>Create Rule</p>*/}
        {/*</Button>*/}
      </div>

      <Heading>BEACH dataset</Heading>

      <RulesList search={searchRule} />
    </div>
  )
}

const mapStateToProps = state => ({
  botAccessors: state.botAccessors,
  adminUser: state.adminUser,
})

// @ts-ignore
export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps)(Rules)))
